import React from "react";
import ExternalLink from "../ExternalLink";

export const NewsletterHome = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 990;

  React.useEffect(() => {
    window.addEventListener("resize", () => setWidth(window.innerWidth));
  }, []);

  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const filterByDate = (newsletters) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const parseLocalDate = (str) => {
      const [y, m, d] = str.split('-').map(Number);
      return new Date(y, m - 1, d);
    };

    return newsletters.filter(d => {
      const startDate = parseLocalDate(d.startDate);
      const endDate = parseLocalDate(d.endDate);
      return today >= startDate && today <= endDate;
    });
  };

  const activeNewsletters = props.data ? filterByDate(props.data) : [];
  const featuredNewsletters = activeNewsletters.filter(d => d.featured);
  const regularNewsletters = activeNewsletters.filter(d => !d.featured);

  return (
    <div id="newsletter-home" className="text-center">
      <div
        className="container-fluid padding-fluid"
        style={
          width < breakpoint
            ? { paddingLeft: "15px", paddingRight: "15px" }
            : {}
        }
      >
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>
            <span className="title">Newsletter</span>
          </h2>
        </div>
        <div className="row">
          <div
            className="col-md-12"
            style={
              width < breakpoint
                ? { paddingLeft: "0px", paddingRight: "0px" }
                : {}
            }
          >
            {activeNewsletters.length === 0 ? (
              <div className="row newsletter-empty-state">
                <div className="col-md-8 col-md-offset-2 col-sm-12 text-center">
                  <div className="empty-state-image">
                    <img
                      src="/img/newsletter/no-newsletters.png"
                      alt="No hay newsletters"
                    />
                  </div>
                  <div className="empty-state-text">
                    <span className="text-regular">
                      No hay noticias publicadas<br className="br-mobile" /> por ahora.
                      <br />
                    </span>
                    <span className="text-bold">
                      Estamos preparando<br className="br-mobile" /> información para<br className="br-desktop" />
                      compartirla contigo.
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <>
            {featuredNewsletters.map((d, index) => {
              return (
                <div
                  key={`featured${index}`}
                  className="col-md-12 featured-newsletter"
                  style={{ marginBottom: "80px" }}
                >
                  <div className="col-md-12">
                    {width < breakpoint ? (
                      <>
                        <div className="col-sm-12">
                          <div
                            className="textNews"
                            dangerouslySetInnerHTML={{ __html: d.title }}
                          ></div>
                        </div>
                        <div className="col-sm-12">
                          <img
                            className="img-responsive"
                            alt="Newsletter"
                            src={d.img}
                          />
                        </div>
                        <div className="col-sm-12 featured-content">
                          <div
                            className="textDescription"
                            dangerouslySetInnerHTML={{ __html: d.description }}
                          ></div>
                          <a href={d.url} target="_blank" rel="noopener noreferrer" className="btn btn-custom">
                            <span>Leer más</span>&nbsp;&nbsp;
                            <img alt="arrow" src="/img/Arrow.png" />
                          </a>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-md-6 col-sm-12 featured-content">
                          <div
                            className="textNews"
                            dangerouslySetInnerHTML={{ __html: d.title }}
                          ></div>
                          <div
                            className="textDescription"
                            dangerouslySetInnerHTML={{ __html: d.description }}
                          ></div>
                          <a href={d.url} target="_blank" rel="noopener noreferrer" className="btn btn-custom">
                            <span>Leer más</span>&nbsp;&nbsp;
                            <img alt="arrow" src="/img/Arrow.png" />
                          </a>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <img
                            className="img-responsive"
                            alt="Newsletter"
                            src={d.img}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}

            {chunk(regularNewsletters, 3).map((e, index) => {
              return (
                <div
                  key={`dv0${index}`}
                  className="col-md-12"
                >
                  {e.map((d, i) => {
                    return (
                      <div
                        key={`dv1${i}`}
                        className="col-md-4 col-sm-6 text-center content-news"
                      >
                        <div key={`dv2${i}`} className="imgContainer">
                          <a href={d.url} target="_blank" rel="noopener noreferrer">
                            <img
                              className="img-responsive"
                              key={`img${i}`}
                              alt="Newsletter"
                              src={d.img}
                            />
                          </a>
                          <div
                            className="textNews"
                            dangerouslySetInnerHTML={{ __html: d.title }}
                            key={`p${i}`}
                          ></div>
                          <div
                            className="textDescription"
                            dangerouslySetInnerHTML={{ __html: d.description }}
                            key={`des${i}`}
                          ></div>
                          <ExternalLink href={d.url} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
